import { render } from "./Paso5InstruccionesComponent.vue?vue&type=template&id=5378752e"
import script from "./Paso5InstruccionesComponent.vue?vue&type=script&lang=js"
export * from "./Paso5InstruccionesComponent.vue?vue&type=script&lang=js"

import "./Paso5InstruccionesComponent.vue?vue&type=style&index=0&id=5378752e&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__